import { useEffect, useState } from 'react';
import api from '@/api/services/achievements';
import AchievementListWihtLoading, { AchievementListWihtLoadingProps } from './AchievementListWihtLoading';

type IProps = Pick<AchievementListWihtLoadingProps, 'role'> & {
  queries: {
    category_id?: string;
    sort?: 'ASC' | 'DSC';
    filter?: string;
    role: null | 'true';
  };
  commanderId?: string;
};

const AchievementListWithApiArmies = (props: IProps) => {
  const [loadingMore, setLoadingMore] = useState(false);
  const isTest = typeof window !== 'undefined' && window?.location?.hostname !== 'landrocker.io';

  const {
    data: achievementData,
    isLoading,
    size,
    setSize,
    mutate,
  } = api.useAllTasks2Infinite({
    for_test: isTest,
    commander_id: props.commanderId,
    ...props.queries,
  });

  let filteredItems = achievementData?.flatMap((page) => page.data.data.Achievement) ?? [];
  filteredItems = filteredItems.filter((item) => item);

  useEffect(() => {
    setLoadingMore(false);
  }, [achievementData]);

  const handleLoadMore = async () => {
    setLoadingMore(true);
    setSize(size + 1);
  };

  const hasMore = achievementData && achievementData[0] && size < achievementData[0].data.meta.pagination.total_pages;
  const loaderActive = loadingMore || isLoading;

  return (
    <AchievementListWihtLoading
      isLoading={isLoading}
      hasMore={hasMore}
      items={filteredItems}
      next={handleLoadMore}
      loaderActive={loaderActive}
      role={props.role}
      mutate={mutate}
    />
  );
};

export default AchievementListWithApiArmies;
